import { render } from "./ManualCostEditModal.vue?vue&type=template&id=b663a956&scoped=true"
import script from "./ManualCostEditModal.vue?vue&type=script&lang=js"
export * from "./ManualCostEditModal.vue?vue&type=script&lang=js"

import "./ManualCostEditModal.vue?vue&type=style&index=0&id=b663a956&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b663a956"]])

export default __exports__